export default {
    title: '現有技術',
    add: '添加現有技術',
    searchPlaceholder: '搜尋專利...',
    noResults: '未找到現有技術',
    searchHint: '添加專利以追蹤相關現有技術',
    viewDetails: '查看專利詳情',
    moreResults: '更多現有技術',
    delete: '刪除',
    cancel: '取消',
    deleteSuccess: '刪除成功',
    deleteFailed: '刪除失敗',
    applicationDate: '申請:',
    publicationDate: '公開:',
    applicant: '申請人:',
    applicantSeparator: '；',
    dialog: {
        title: '添加現有技術',
        subtitle: '按專利號搜尋或描述發明內容。',
        placeholder: '例如 US20230123456 或描述發明：\'一種採用彈簧臂的自定心對準機構的光纖連接器...\'',
        proTip: '專業提示：粘貼完整段落可獲得更好的語義匹配效果。',
        search: '搜尋',
        searching: '搜尋中...',
        found: '找到',
        results: '條結果',
        enterQuery: '輸入查詢開始搜尋',
        noResults: '未找到匹配的專利',
        resultsWillAppear: '搜尋結果將顯示在此處',
        searchFailed: '搜尋失敗，請稍後重試',
        selected: '已選擇',
        cancel: '取消',
        addSelected: '添加所選',
        noSelected: '請至少選擇一個專利',
        addSuccess: '成功添加 {count} 個專利',
        addFailed: '添加專利失敗，請重試',
        aiSemanticSearch: 'AI 語義檢索',
    },
};
